import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiButton, ContentTemplate, SectionHeader } from 'web-library';
import { useHistory } from 'react-router-dom';
import LateApplicationDialog from '../../modules/accessArrangment/components/candidate/ImportantNotes/LateApplicationDialog';
import PendingApplicationDetails from '../../modules/accessArrangment/components/candidate/ImportantNotes/PendingApplicationDetails';
import key from '../../routes/key';
import { candidateService } from '../../api';
import { usePostTransactionLog } from '../../api-refactored/candidate/usePostTransactionLog';
import ImportantNotesContent from '../../modules/accessArrangment/components/candidate/ImportantNotes/ImportantNotesContent';
import { useWOGAA } from '../../hooks/wogaa';

const { accessArrangement } = key.child;
const { root: aaRoot, selectCondition } = key['access-arrangement'].child;

const ImportantNotes = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { t } = useTranslation();
  const history = useHistory();
  const [draftData, setDraftData] = useState<any>([]);

  const draftDataMutate = candidateService.accessArrangement.candidate.usePostAppealArrangementDraft(
    (res) => {
      setDraftData(res.data);
    },
    () => {
      // Do nothing on no response
    }
  );

  const postRequest = candidateService.accessArrangement.candidate.usePostAppealArrangementCreateApplication(
    ({ data }) => {
      const { uuid } = data;
      history.push(`/${accessArrangement}/${aaRoot.route}/${selectCondition.route}/${uuid}`);
    },
    () => {
      // Do nothing on no response
    }
  );

  const { mutate: apiMutate } = usePostTransactionLog();

// wogga tracking start for AA application by candidate
  const { transactionStart } = useWOGAA('myexamsseab-6465');

  useEffect(() => {
    draftDataMutate.mutate({});
    /*  eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  const lateApplication = false;
  const pendingApplication = useMemo(() => {
    if (draftData?.uuid) {
      return true;
    }
    return false;
  }, [draftData]);

  const handleStartApplication = () => {
    transactionStart();
    if (draftData?.uuid) {
      apiMutate({
        auditActionType: 'CONTINUE_ACCESS_ARRANGEMENT_REQUEST',
        applicationId: draftData.applicationNo,
      });
      history.push(
        `/${accessArrangement}/${aaRoot.route}/${selectCondition.route}/${draftData.uuid}`
      );
    } else {
      postRequest.mutate({});
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  return (
    <>
      <ImportantNotesContent />
      <ContentTemplate continuous>
        <SectionHeader title={t('accessArrangement->>Notes.GetStarted')} />
        {pendingApplication && draftData && (
          <PendingApplicationDetails
            applicationNo={draftData.applicationNo}
            examLevel={draftData.examLevels.length === 0 ? '-' : draftData.examLevels.join(', ')}
          />
        )}
        <ApiButton
          id="access-arrangement-start-button"
          onClick={lateApplication ? handleOpenDialog : handleStartApplication}
          status={postRequest.status}
        >
          {pendingApplication
            ? t('accessArrangement->>Notes.ContinueApplication')
            : t('accessArrangement->>Notes.StartApplication')}
        </ApiButton>
      </ContentTemplate>
      <LateApplicationDialog
        onProceed={handleStartApplication}
        onCancel={handleCloseDialog}
        open={dialogOpen}
      />
    </>
  );
};

export default ImportantNotes;
